document.addEventListener("DOMContentLoaded", function(){
    function closePopover(triggerElement, id){
        let popoverWrapper = (triggerElement != null) ? triggerElement : document.querySelector('[data-popover-id="desktop-'+id+'"]')
        popoverWrapper.style.visibility = "hidden";
        popoverWrapper.style.transform = "translate(100%)";
        let popoverInnerWrapper = popoverWrapper.querySelector('.custom-shop-the-look__popover');
        popoverInnerWrapper.style.visibility = "hidden";
        popoverInnerWrapper.style.transform = "translate(100%)";
    };
    function openPopover(id){
        let popoverWrapper = document.querySelector('[data-popover-id="desktop-'+id+'"]')
        popoverWrapper.style.visibility = "visible";
        popoverWrapper.style.transform = "translate(0)";
        let popoverInnerWrapper = popoverWrapper.querySelector('.custom-shop-the-look__popover');
        popoverInnerWrapper.style.visibility = "visible";
        popoverInnerWrapper.style.transform = "translate(0)";
    }
    let showProductsBtns = document.querySelectorAll('.custom-stl-btn');
    showProductsBtns.forEach((showProductBtn) => {
        showProductBtn.addEventListener('click', function(){
            openPopover(showProductBtn.dataset.id)
        })
    })
    let closeProductsBtns = document.querySelectorAll('.icon-close-wrapper');
    closeProductsBtns.forEach((closeProductsBtn) => {
        closeProductsBtn.addEventListener('click', function(){
            closePopover(triggerElement=null, closeProductsBtn.dataset.popoverClose);
        })
    }) 
    let targetElements = document.querySelectorAll('.custom-shop-the-look__popover');
    targetElements.forEach((targetElement) => {
        let parentElement = targetElement.parentElement;
        parentElement.addEventListener('click', function(event){
            if(!targetElement.contains(event.target)){
                closePopover(parentElement, id=null);
            }
        })
    }) 

    let addToCartBtns = document.querySelectorAll('.popover-quick-add-btn');
    addToCartBtns.forEach((addToCartBtn) => {
        addToCartBtn.addEventListener('click', function(){
            closePopover(triggerElement=null, addToCartBtn.dataset.addToCartId);
        })
    })
})